<template>
  <marquee-text v-if="!!announcement" class="marquee" @click="handleClick" :repeat="1">
    {{ announcement.content }}
  </marquee-text>
</template>

<script>
import { mapState } from 'vuex'
import MarqueeText from 'vue-marquee-text-component'
import WindowsMixin from '@/mixins/windows'
export default {
  name: 'Announcement',
  components: {
    MarqueeText,
  },
  mixins: [WindowsMixin],
  computed: {
    ...mapState('notify', ['announcements']),
    announcement () {
      return this.announcements?.[0]
    },
  },
  methods: {
    handleClick () {
      this.createDialog('AnnouncementNotifyDialog', {
        announcement: this.announcement,
      })
    },
  },
}
</script>

<style>
.marquee {
  width: 100%
}
</style>
